/* eslint-disable max-len */
import Category from './Category';
import ToolBoxContainer, { FlatToolBoxContainer } from './ToolBoxContainer';
import { BlockTypeConsts } from '../blockly/setting/BlockTypeConsts';
import { GlobalImport } from '../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();

// 基本カテゴリ
import { SceneStartBlock } from '../blockly/elements/SceneStartBlock';
import { ArSceneStartBlock } from '../blockly/elements/ArSceneStartBlock';

import { ColorAttribute } from '../blockly/attributes/ColorAttribute';
import { BlockElement } from '../blockly/elements/BlockElement';
import { LightElement } from '../blockly/elements/LightElement';
// import { CameraElement } from '../blockly/elements/CameraElement';
import { CameraElement_v2_1 } from '../blockly/elements/CameraElement_v2_1';
import { ImageElement } from '../blockly/elements/ImageElement';
import { ImageElement_v2 } from '../blockly/elements/ImageElement_v2';
// import { LayoutBoxElement } from '../blockly/elements/LayoutBoxElement';
// import { LayoutLineElement } from '../blockly/elements/LayoutLineElement';
// import { LayoutCircleElement } from '../blockly/elements/LayoutCircleElement';

import { TextElement } from '../blockly/elements/TextElement';
import { LinkElement } from '../blockly/elements/LinkElement';
import { JaTextElementBlock } from '../blockly/elements/JaTextElementBlock';
import { EntityElement } from '../blockly/elements/EntityElement';
import { ZoomElement } from '../blockly/elements/ZoomElement';

// 属性
import { VR3InputAttribute } from '../blockly/attributes/VR3InputAttribute';
import { ColorValue } from '../blockly/attributes/ColorValue';
import { RandomPositionAttribute } from '../blockly/attributes/RandomPositionAttribute';
import { RandomColorAttribute } from '../blockly/attributes/RandomColorAttribute';
import { RandomScaleAttribute } from '../blockly/attributes/RandomScaleAttribute';
import { AheadAttribute } from '../blockly/attributes/AheadAttribute';
import { ImageSrcAttribute } from '../blockly/attributes/ImageSrcAttribute';
import { ClickableAttribute } from '../blockly/attributes/ClickableAttribute';
import { PushAttribute } from '../blockly/attributes/PushAttribute';
import { ConsoleOnAttribute } from '../blockly/attributes/ConsoleOnAttribute';
import { CheckPointAttribute } from '../blockly/attributes/CheckPointAttribute';
import { LookAtAttribute } from '../blockly/attributes/LookAtAttribute';
import { InFrontOfAttribute } from '../blockly/attributes/InFrontOfAttribute';

// import { FogAttribute } from '../blockly/attributes/FogAttribute';
// import { NoAvatorAttribute } from '../blockly/attributes/NoAvatorAttribute';
import { OpacityAttribute } from '../blockly/attributes/OpacityAttribute';
import { ClassAttribute } from '../blockly/attributes/ClassAttribute';
import { VrmAnimAttribute } from '../blockly/attributes/VrmAnimAttribute';

// 物理
import { DynamicBodyAttribute } from '../blockly/attributes/DynamicBodyAttribute';
import { StaticBodyAttribute } from '../blockly/attributes/StaticBodyAttribute';
import { PhysicsSystemAttribute } from '../blockly/attributes/PhysicsSystemAttribute';
import { CollideStartBlock } from '../blockly/elements/CollideStartBlock';

// 背景
import { OceanElement } from '../blockly/elements/OceanElement';
import { EnvironmentElement } from '../blockly/elements/EnvironmentElement';

// AR
import { ARBarcodeAttribute } from '../blockly/attributes/ARBarcodeAttribute';
import { ARSceneSettingAttribute } from '../blockly/attributes/ARSceneSettingAttribute';
import { ARGpsAttribute } from '../blockly/attributes/ARGpsAttribute';
import { ARMarkerFoundBlock } from '../blockly/elements/ARMarkerFoundBlock';

import { ARImageTrackMarkerBlock } from '../blockly/elements/ARImageTrackMarkerBlock';
import { ARImageSceneSettingAttribute } from '../blockly/attributes/ARImageSceneSettingAttribute';
import { ARFaceSceneSettingAttribute } from '../blockly/attributes/ARFaceSceneSettingAttribute';

import { ARImageMarkerBlock } from '../blockly/elements/ARImageMarkerBlock';
import { ARFaceMarkerBlock } from './elements/ARFaceMarkerBlock';

// Poly
import { SketchFabDialogButton } from './other/SketchFabDialogButton';
// import { GooglePolyAttribute } from '../blockly/attributes/GooglePolyAttribute';
// Logic
import { IfElseBlock } from '../blockly/logic/IfElseBlock';
import { IfBlock } from '../blockly/logic/IfBlock';
import { RangeLoopBlock } from '../blockly/logic/RangeLoopBlock';
import { EqualBlock } from '../blockly/logic/EqualBlock';
import { GreaterThanBlock } from '../blockly/logic/GreaterThanBlock';
import { LessThanBlock } from '../blockly/logic/LessThanBlock';
import { SetValueBlock } from '../blockly/logic/SetValueBlock';
import { FunctionBlock } from '../blockly/logic/FunctionBlock';
import { FunctionCallBlock } from '../blockly/dynamic_action/FunctionCallBlock';
import { LogicalOperatorBlock } from '../blockly/logic/LogicalOperatorBlock';
import { NotOperatorBlock } from '../blockly/logic/NotOperatorBlock';
import { IdAttribute } from '../blockly/attributes/IdAttribute';
import { SetArrayBlock } from '../blockly/logic/SetArrayBlock';
import { ListLoopBlock } from '../blockly/logic/ListLoopBlock';
import { CommentOutBlock } from '../blockly/logic/CommentOutBlock';
import { FollowRotationAttribute } from '../blockly/attributes/FollowRotationAttribute';
import { UpdateAttributeBlock } from '../blockly/logic/UpdateAttributeBlock';
import { InitProcessBlock } from '../blockly/logic/InitProcessBlock';

// import { AjaxLoaderElements } from '../blockly/dynamic_action/AjaxLoaderElements';
// import { RepeatLoopBlock } from '../blockly/dynamic_action/RepeatLoopBlock';
// import { UntilLoopBlock } from '../blockly/dynamic_action/UntilLoopBlock';

// コマンド
import { ConsoleLogFunction } from '../blockly/command/ConsoleLogFunction';
import { OnClickAttribute } from '../blockly/attributes/OnClickAttribute';
// import { VR3SetBlock } from '../blockly/command/VR3SetBlock';
// import { VR3StepByBlock } from '../blockly/command/VR3StepByBlock';
// import { StepByBlock } from '../blockly/command/StepByBlock';
// import { SetBlock } from '../blockly/command/SetBlock';
// import { DistanceToBlock } from '../blockly/command/DistanceToBlock';

import { Label } from '../blockly/elements/Label';
import { SkyElement } from '../blockly/elements/SkyElement';
import { ColorSettings } from '../blockly/setting/ColorSettings';
import { ARMarkerListButton } from '../blockly/other/ARMarkerListButton';
import { FileUploaderButton } from '../blockly/other/FileUploaderButton';
import { LinkSelectButton } from '../blockly/other/LinkSelectButton';

import { ARMarkerBlock } from '../blockly/elements/ARMarkerBlock';
import { ARHiroAttribute } from '../blockly/attributes/ARHiroAttribute';
import { VideoElement } from '../blockly/elements/VideoElement';
import { SoundElement } from '../blockly/elements/SoundElement';
import { SoundSrcAttribute } from '../blockly/attributes/SoundSrcAttribute';
import { glTFModelElement } from '../blockly/elements/glTFModelElement';
import { ModelVrmElement } from './elements/ModelVrmElement';

// Any
import { AnyElement } from '../blockly/elements/AnyElement';
import { AnyAttribute } from '../blockly/attributes/AnyAttribute';
import { AnyLibrary } from '../blockly/custom/AnyLibrary';
import { AnyAssets } from '../blockly/custom/AnyAssets';

import { ARGpsCameraOnAttribute } from '../blockly/attributes/ARGpsCameraOnAttribute';
import { GPSSelectButton } from '../blockly/other/GPSSelectButton';
import { SimplePasswordElement } from '../blockly/elements/SimplePasswordElement';

import { ModelViewSceneBlock } from '../blockly/elements/ModelViewSceneBlock';
import { ModelViewSceneSimpleBlock } from '../blockly/elements/ModelViewSceneSimpleBlock';
import { Flicker360ImageButton } from '../blockly/other/Flicker360ImageButton';
import { Permission } from '../utils/Permission';
import { NetworkedAttribute } from '../blockly/attributes/NetworkedAttribute';
import { block_translation } from '../lang/BlockTranslation';

// import {TorusElement} from "../blockly/elements/TorusElement";

const t = block_translation;

export const createToolbox = () => {
  const toolBox = new ToolBoxContainer();

  // ライブラリ名の定義
  // const EXTRAS_LIB = ''; // `${location.protocol}//${location.host}/public/aframe-extras_bundle.js`;
  // const PHYSICS_LIB = `https://unpkg.com/aframe-physics-system@3.3.0/dist/aframe-physics-system.min.js`;
  // patchversion
  // const AMMO_LIB = 'https://mixedreality.mozilla.org/ammo.js/builds/ammo.wasm.js';
  // const AMMO_LIB = "http://kripken.github.io/ammo.js/builds/ammo.wasm.js";
  // const AMMO_LIB ="https://cdn.jsdelivr.net/gh/MozillaReality/ammo.js@8bbc0ea/builds/ammo.wasm.js"
  const AMMO_LIB = '../public/libs/ammo.wasm.js';
  //const PHYSICS_LIB =  'https://rawcdn.githack.com/kylebakerio/aframe-physics-system/f7117be8f83cb75ff870941883b7973ff92d0a34/dist/aframe-physics-system.min.js';
  // const PHYSICS_LIB = "https://cdn.jsdelivr.net/npm/aframe-physics-system@4.0.1/dist/aframe-physics-system.js"
  const PHYSICS_LIB = '../public/libs/aframe-physics-system.js';

  // const AR_LIB = 'https://raw.githack.com/AR-js-org/AR.js/master/aframe/build/aframe-ar-nft.js';
  //const AR_LIB = '../public/libs/aframe-ar-nft.js';
  const AR_LIB = '../public/libs/aframe-ar-marker.js';

  // const MINDAR_LIB = '../public/libs/mindar-image.prod.js'; // TODO:ARシーンスタートにベタガキしてる
  const MINDAR_AFRAME_LIB = '../public/libs/mindar-image-aframe.prod.js';
  const MINDAR_FACE_AFRAME_LIB = '../public/libs/mindar-face-aframe.prod.js';
  const VRM_LIB = '../public/libs/aframe-vrm.min.js';

  // 基本
  const scene = new Category(t.to('シーン', 'scene'), ColorSettings.SceneColor);
  scene.add(new SceneStartBlock());
  scene.add(new ArSceneStartBlock());
  scene.add(new ARSceneSettingAttribute().setLibrary(AR_LIB));

  // scene.add(
  //   new ARImageSceneSettingAttribute().setLibrary(MINDAR_LIB).setLibrary(MINDAR_AFRAME_LIB)
  // );
  scene.add(new ARImageSceneSettingAttribute().setLibrary(MINDAR_AFRAME_LIB));
  scene.add(new ARFaceSceneSettingAttribute().setLibrary(MINDAR_FACE_AFRAME_LIB));

  scene.add(new PhysicsSystemAttribute().setLibrary(PHYSICS_LIB));
  scene.add(new ConsoleOnAttribute());
  // scene.add(new NoAvatorAttribute());
  if (Permission.onlyAdmin) {
    scene.add(new ZoomElement());
  }
  toolBox.addCategory(scene);

  const basic = new Category(t.to('物理', 'entity'), ColorSettings.ObjectColor);
  // basic.add(new SceneStartBlock("a-scene-start","シーンスタート").setNameForCode("a-scene").isHat(true));
  basic.add(new BlockElement(BlockTypeConsts.CUBE, t.to('直方体', 'box')).setNameForCode('box'));
  basic.add(
    new BlockElement(BlockTypeConsts.SPHERE, t.to('球体', 'sphere')).setNameForCode('sphere')
  );
  // basic.add(new TorusElement())
  basic.add(new TextElement().setNameForCode('a-text'));

  // 画像ブロック
  basic.add(new ImageElement_v2());

  // 日本語文字 deprecated Textに寄せる
  basic.add(
    new JaTextElementBlock(t.to('半角英数字ひらがなカタカナ', 'multibyte')).setIsInToolbox(false)
  ); //.setLibrary("https://unpkg.com/aframe-html-shader@0.2.0/dist/aframe-html-shader.min.js").setIsInToolbox(false) );

  basic.add(
    new CameraElement_v2_1(BlockTypeConsts.CAMERA_V2_1)
      .setNameForCode('a-camera')
      .setIsInToolbox(true)
  );

  // basic.add(new LayoutLineElement().setIsInToolbox(false)); //.setLibrary("https://unpkg.com/aframe-layout-component@5.3.0/dist/aframe-layout-component.min.js"));
  // basic.add(new LayoutBoxElement().setIsInToolbox(false)); //.setLibrary("https://unpkg.com/aframe-layout-component@5.3.0/dist/aframe-layout-component.min.js"));
  // basic.add(new LayoutCircleElement().setIsInToolbox(false)); //.setLibrary("https://unpkg.com/aframe-layout-component@5.3.0/dist/aframe-layout-component.min.js"));

  basic.add(new EntityElement());

  toolBox.addCategory(basic);

  const attribute = new Category(t.to('属性', 'attribute'), ColorSettings.AttributeColor);
  attribute.add(new AheadAttribute());
  attribute.add(
    new VR3InputAttribute(BlockTypeConsts.SPINNING, t.to('常に回転', 'spinning'))
      .setNameForCode('spinning')
      .setDefaultXYZ(0, 1, 0)
  );

  attribute.add(new LookAtAttribute());

  attribute.add(new IdAttribute(BlockTypeConsts.ID, 'ID').setNameForCode('id'));
  attribute.add(
    new VR3InputAttribute(BlockTypeConsts.POSITION, t.to('位置', 'position'))
      .setNameForCode('position')
      .setDefaultXYZ('0', '1', '0')
  );
  attribute.add(
    new VR3InputAttribute(BlockTypeConsts.ROTATION, t.to('回転', 'rotation'))
      .setNameForCode('rotation')
      .setDefaultXYZ(360, 360, 360)
  );

  attribute.add(
    new VR3InputAttribute('scale_v2', t.to('大きさ', 'scale'))
      .setNameForCode('scale')
      .setDefaultXYZ(1, 1, 1)
  );
  // attribute.add(new SizeAttribute('size_w_h_d_v2', '幅高さ奥行き').setNameForCode('fixed-size').setIsInToolbox(false)); // 倍率を使わない固定サイズ
  attribute.add(new CheckPointAttribute());
  attribute.add(new OpacityAttribute());
  attribute.add(new ClassAttribute());
  attribute.add(new VrmAnimAttribute().setIsInToolbox(false));
  // 非表示
  // attribute.add(new FogAttribute().setIsInToolbox(false));

  // 非表示の色の値
  attribute.add(
    new ColorValue('color_value_v2', t.to('色', 'color'))
      .setNameForCode('color')
      .setIsInToolbox(false)
  );
  attribute.add(new ColorAttribute());

  // 画像
  attribute.add(new ImageSrcAttribute().setNameForCode('src').setIsInToolbox(false));
  attribute.add(new ClickableAttribute('clickable_v2', 'クリック可能にする').setIsInToolbox(false));
  attribute.add(new PushAttribute().setNameForCode('push').setIsInToolbox(true));

  /**
   * ランダム
   */
  attribute.add(
    new RandomPositionAttribute('random-position', t.to('ランダムな位置', 'random_pos'))
  );
  attribute.add(new RandomScaleAttribute('random-scale', t.to('ランダムな大きさ', 'random_scale')));
  attribute.add(new RandomColorAttribute('random-color', t.to('ランダムな色', 'random_color')));

  attribute.add(new FollowRotationAttribute());
  attribute.add(new InFrontOfAttribute());
  attribute.add(new NetworkedAttribute());

  toolBox.addCategory(attribute);

  const env = new Category(t.to('環境', 'env'), ColorSettings.EnvironmentColor);
  env.add(new EnvironmentElement(BlockTypeConsts.ENVIRONMENT, t.to('背景', 'background')));
  // env.add(new ElementBlockWithoutSubBlock("a-grid","格子の地面").setLibrary("https://cdn.jsdelivr.net/gh/donmccurdy/aframe-extras@v6.0.1/dist/aframe-extras.min.js"));
  env.add(new SkyElement(BlockTypeConsts.SKY, t.to('全天球', 'sky')));
  const ocean = new OceanElement(BlockTypeConsts.OCEAN, t.to('水面', 'ocean')).setNameForCode(
    'a-ocean'
  );
  ocean.setIsInToolbox(false);
  env.add(ocean); //.setLibrary(EXTRAS_LIB)
  env.add(new LightElement());
  toolBox.addCategory(env);

  // 環境ライブラリ https://github.com/feiss/aframe-environment-component
  const physics = new Category(t.to('物理エンジン', 'physics'), ColorSettings.PhysicsSystemColor);
  physics.add(new DynamicBodyAttribute()).setLibrary([AMMO_LIB, PHYSICS_LIB]);

  physics.add(new StaticBodyAttribute()).setLibrary([AMMO_LIB, PHYSICS_LIB]);

  physics.add(new CollideStartBlock()).setLibrary([AMMO_LIB, PHYSICS_LIB]);
  toolBox.addCategory(physics);

  // AR
  const ar = new Category(t.to('AR', 'ar'), ColorSettings.ARColor);
  // ar.add(new ARCameraElement(BlockTypeConsts.AR_CAMERA,"ARカメラ").setNameForCode("a-marker-camera")
  // .setLibrary(`${location.protocol}//${location.host}/public/aframe-ar_bundle.js`));
  ar.add(
    new ARMarkerBlock(BlockTypeConsts.AR_MARKER, t.to('ARマーカー', 'ar_marker'))
      .setNameForCode('a-marker')
      .setLibrary(AR_LIB)
  );
  ar.add(new ARHiroAttribute().setNameForCode('preset').setLibrary(AR_LIB));
  ar.add(
    new ARBarcodeAttribute(
      BlockTypeConsts.AR_BARCODE_ATTRIBUTE,
      t.to('QRコードマーカー', 'qr_marker')
    )
      .setNameForCode('barcode')
      .setLibrary(AR_LIB)
  );

  const arMarkerFound = new ARMarkerFoundBlock();
  arMarkerFound.setIsInToolbox(false);
  if (Permission.overStandard) {
    arMarkerFound.setIsInToolbox(true);
  }
  ar.add(arMarkerFound);

  // const arImageTraceMarker = new ARImageTrackMarkerBlock();
  // arImageTraceMarker.setIsInToolbox(false);
  // if (Permission.onlyAdmin) {
  //   arImageTraceMarker.setIsInToolbox(true);
  // }
  // ar.add(arImageTraceMarker);

  ar.add(new ARImageMarkerBlock());

  ar.add(new ARFaceMarkerBlock());

  // AR Gps
  const arGpsCameraOn = new ARGpsCameraOnAttribute().setLibrary(AR_LIB);
  const arGps = new ARGpsAttribute().setLibrary(AR_LIB);
  arGpsCameraOn.setIsInToolbox(false);
  arGps.setIsInToolbox(false);
  if (Permission.overStandard) {
    arGpsCameraOn.setIsInToolbox(true);
    arGps.setIsInToolbox(true);
  }
  ar.add(arGpsCameraOn);
  ar.add(arGps);

  // マーカー一覧ボタン
  ar.add(new ARMarkerListButton());

  toolBox.addCategory(ar);

  const logicCategory = new Category(t.to('制御', 'control'), ColorSettings.LogicColor);
  logicCategory._hasLogic = true;
  // logicCategory.setLibrary('https://cdn.jsdelivr.net/npm/aframe-template-component@3.2.1/dist/aframe-template-component.min.js');
  logicCategory.add(new RangeLoopBlock());
  // logicCategory.add(new UntilLoopBlock());
  // logicCategory.add(new RepeatLoopBlock());
  logicCategory.add(new ListLoopBlock().setNameForCode('list-loop'));
  logicCategory.add(new IfBlock('logic_if_v2').setNameForCode('if'));
  logicCategory.add(new IfElseBlock().setNameForCode('ifelse'));
  logicCategory.add(new SetValueBlock().setNameForCode('set_value'));
  logicCategory.add(new SetArrayBlock().setNameForCode('set_array'));
  logicCategory.add(new UpdateAttributeBlock());
  logicCategory.add(new Label());

  // const ajaxElement = new AjaxLoaderElements();
  // ajaxElement.setIsInToolbox(false);
  // if (Permission.onlyAdmin) {
  //   ajaxElement.setIsInToolbox(true);
  // }
  // logicCategory.add(ajaxElement);

  logicCategory.add(new CommentOutBlock());
  toolBox.addCategory(logicCategory);

  const operatorCategory = new Category(t.to('演算', 'operator'), ColorSettings.OperatorColor);
  // operatorCategory.setLibrary('https://cdn.jsdelivr.net/npm/aframe-template-component@3.2.1/dist/aframe-template-component.min.js');
  operatorCategory.add(
    new EqualBlock('logic_equal_v2', t.to('イコール', 'operator_eq')).setNameForCode('equal')
  );
  operatorCategory.add(new GreaterThanBlock().setNameForCode('greater_than'));
  operatorCategory.add(new LessThanBlock().setNameForCode('less_than'));
  operatorCategory.add(
    new LogicalOperatorBlock('logic_and_v2', t.to('かつ', 'operator_and')).setCalcurator(
      '&&',
      t.to('かつ', 'operator_and')
    )
  );
  operatorCategory.add(
    new LogicalOperatorBlock('logic_anor_v2', t.to('または', 'operator_or')).setCalcurator(
      '||',
      t.to('または', 'operator_or')
    )
  );
  operatorCategory.add(new NotOperatorBlock());

  toolBox.addCategory(operatorCategory);

  const moreCategory = new Category(t.to('ブロック定義', 'function_def'), ColorSettings.MoreColor);
  // moreCategory.setLibrary('https://cdn.jsdelivr.net/npm/aframe-template-component@3.2.1/dist/aframe-template-component.min.js');
  moreCategory.add(new FunctionBlock('logic_function_v2').setNameForCode('function'));
  moreCategory.add(new FunctionCallBlock('logic_function_call_v').setNameForCode('function_call'));
  moreCategory.add(new InitProcessBlock('logic_init_process').setNameForCode('init_process'));
  moreCategory.add(new OnClickAttribute().setNameForCode('onclick'));
  moreCategory.add(new ConsoleLogFunction().setIsInToolbox(false));

  // const setPosition = new VR3SetBlock('position');
  // const stepPosition = new VR3StepByBlock('position');
  // // const setRotation = new VR3SetBlock('rotation');
  // // const stepRotation = new VR3StepByBlock('rotation');
  // // const setScale = new VR3SetBlock('scale');
  // // const stepScale = new VR3StepByBlock('scale');
  // // const setBlock = new SetBlock();
  // // const stepBlock = new StepByBlock();
  // const distanceTo = new DistanceToBlock();

  // 動的なブロックは、一旦管理者以外非表示
  // setPosition.setIsInToolbox(false);
  // stepPosition.setIsInToolbox(false);
  // // setRotation.setIsInToolbox(false);
  // // stepRotation.setIsInToolbox(false);
  // // setScale.setIsInToolbox(false);
  // // stepScale.setIsInToolbox(false);
  // // setBlock.setIsInToolbox(false);
  // // stepBlock.setIsInToolbox(false);
  // distanceTo.setIsInToolbox(false);
  if (Permission.onlyAdmin) {
    // setPosition.setIsInToolbox(true);
    // stepPosition.setIsInToolbox(true);
    // setRotation.setIsInToolbox(true);
    // stepRotation.setIsInToolbox(true);
    // setScale.setIsInToolbox(true);
    // stepScale.setIsInToolbox(true);
    // setBlock.setIsInToolbox(true);
    // stepBlock.setIsInToolbox(true);
    // distanceTo.setIsInToolbox(true);
  }
  // moreCategory.add(setPosition);
  // moreCategory.add(stepPosition);
  // // moreCategory.add(setRotation);
  // // moreCategory.add(stepRotation);
  // // moreCategory.add(setScale);
  // // moreCategory.add(stepScale);
  // // moreCategory.add(setBlock);
  // // moreCategory.add(stepBlock);
  // moreCategory.add(distanceTo);
  toolBox.addCategory(moreCategory);

  const additionalCategory = new Category(t.to('追加', 'additional'), ColorSettings.OtherColor);

  additionalCategory.add(new SketchFabDialogButton('SketchFabでモデルを検索'));

  // additionalCategory.add(
  //   new GooglePolyAttribute(t('main.blocks.refPoly'))
  //     .setLibrary('https://cdn.jsdelivr.net/npm/aframe-gblock@1.0.2/dist/gblock.min.js')
  //     .setIsInToolbox(false)
  // );
  // additionalCategory.add(
  //   new BlockElement(BlockTypeConsts.ENTITY, t('main.blocks.entity'))
  //     .setNameForCode('a-entity')
  //     .setIsInToolbox(false)
  // );

  additionalCategory.add(new LinkElement().setNameForCode('a-link').setIsInToolbox(false));
  additionalCategory.add(new SoundElement().setNameForCode('a-sound').setIsInToolbox(false));
  additionalCategory.add(new VideoElement().setNameForCode('a-video').setIsInToolbox(false));
  additionalCategory.add(new glTFModelElement().setIsInToolbox(false)); //.setLibrary(EXTRAS_LIB)
  additionalCategory.add(new ModelVrmElement().setIsInToolbox(false).setLibrary(VRM_LIB));

  additionalCategory.add(new SoundSrcAttribute().setIsInToolbox(false));
  additionalCategory.add(new FileUploaderButton());
  additionalCategory.add(new Flicker360ImageButton());

  if (Permission.onlyAdmin) {
    additionalCategory.add(new LinkSelectButton(t.to('他の世界へのリンクを作る', 'links')));
    additionalCategory.add(new GPSSelectButton('GPS位置情報選択'));
  }

  additionalCategory.add(new ImageElement().setIsInToolbox(false));

  if (Permission.overStandard) {
    additionalCategory.add(new AnyElement().setIsInToolbox(true));
    additionalCategory.add(new AnyAttribute().setIsInToolbox(true));
    additionalCategory.add(new AnyLibrary().setIsInToolbox(true));
    additionalCategory.add(new AnyAssets().setIsInToolbox(true));
    additionalCategory.add(new SimplePasswordElement().setIsInToolbox(true));
    additionalCategory.add(new ModelViewSceneBlock().setIsInToolbox(false));
  }
  additionalCategory.add(new ModelViewSceneSimpleBlock().setIsInToolbox(false));
  toolBox.addCategory(additionalCategory);

  /**
   * 縦向きの画面様用のツールボックス
   */
  const allBlocks = new Category('All', ColorSettings.AllColor);
  toolBox.getAllCategoryAllBlocks().forEach((block) => {
    allBlocks.add(block);
  });
  const toolBoxVirtical = new FlatToolBoxContainer();
  toolBoxVirtical.addCategory(allBlocks);
  return toolBox;
};
